<!-- edit mode toggle -->
<div class="row justify-content-between no-gutters" *ngIf="hasPermissionEditorOrAdmin$ | async ">
    <div class="col-10">
        <!-- empty div for justify content -->
        <div *ngIf="editMode && !isLoading">
            <div class="row">
                <div class="col-12 pb-3">
                    <h4 i18n="@@find-information-light-help-header">Edit find information</h4>
                </div>
            </div>
            <div class="row pb-3">
                <div class="col-lg-6 col-md-12">
                    <div>
                        <p>
                            <span class="text-muted">
                                <b><span i18n="@@find-information-light-component-help-channels">Channels</span>: </b>
                                <span i18n="@@find-information-light-component-help-channels-desc">
                                    Adding a channel tag to a navigation
                                    node makes that node only appear for users following that channel. Nodes that are targeted using
                                    channels will have a tag icon displayed next to them. In edit mode you can see all nodes regardless of
                                    channel.
                                </span>
                            </span>
                        </p>
                    </div>
                    <div>
                        <p>
                            <span class="text-muted">
                                <b><span i18n="@@find-information-light-component-help-note">Headings</span>: </b>
                                <span i18n="@@find-information-light-component-help-note-desc">
                                    Headings without links beneath them will
                                    be displayed as links when exiting edit mode. this is to allow having only one level of links directly
                                    under a section.
                                </span>
                            </span>
                        </p>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div>
                        <p>
                            <span class="text-muted">
                                <b><span i18n="@@find-information-light-component-help-order">Order</span>: </b>
                                <span i18n="@@find-information-light-component-help-order-desc">
                                    You can change the order of sections,
                                    headings and links through drag-and-drop. However you can only move nodes within a given level. For
                                    example you can change the order of headings in a section but you cannot move a heading into another
                                    section.
                                </span>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div>
        <mat-slide-toggle [checked]="editMode" i18n="@@edit" (change)="handleEditMode($event)">Edit</mat-slide-toggle>
    </div>
</div>

<div class="menu-container row" *ngIf="navigationNodes$ | async as navigationNodes; else loading"
     [sortablejs]="editMode ? navigationNodes : []"
     [sortablejsOptions]="editMode ? options : {disabled:true}">

    <!-- top level node -->
    <!-- sortable in edit mode-->
    <div class="menu-item col-xs-12 col-sm-6 col-xl-4 container-level-1" *ngFor="let node of navigationNodes">

        <!-- hr element used to add borders to each section-->
        <hr />
        <h4 class="node-style-level-1 ">
            <a *ngIf="!editMode" class="link-text-color font-weight-bold" [ngClass]="!node.Url || node.Url === '' ? 'text-decoration-none' : ''" [attr.href]="node.Url && node.Url !== '' ? node.Url : null">
                {{node.Title}}
            </a>
            <i *ngIf="editMode" class="ms-Icon ms-Icon--GripperDotsVertical drag-handle pl-1 pr-1" aria-hidden="true"></i>
            <a *ngIf="editMode" class="link-text-color font-weight-bold clickable"
               [routerLink]="['',{ outlets: { modal: ['find-information','edit',node.Id] } }]">
                {{node.Title}}<i *ngIf="!isLoading && node.ChannelTermNavigationNodes && node.ChannelTermNavigationNodes.length > 0" [ngClass]="{'fa-tag': node.ChannelTermNavigationNodes.length === 1, 'fa-tags': node.ChannelTermNavigationNodes.length > 1}" class="fa ml-2"></i>
            </a>
        </h4>
        <br>
        <ng-container *ngIf="editMode && !isLoading && languageFilteringEnabled && node.LanguageTermNavigationNodes && node.LanguageTermNavigationNodes.length > 0">
          <i class="fa fa-flag-o ml-2 mr-2"></i>
          <span class="text-muted"> {{getNodeLanguages(node.LanguageTermNavigationNodes)}} </span>
        </ng-container>

        <!-- level 2 nodes -->
        <!-- sortable in edit mode-->
        <ul [sortablejs]="editMode ? node.Children : []"
            [sortablejsOptions]="editMode ? options : {disabled:true}">
            <li *ngFor="let subNode of node.Children">
                <!-- Show level 2 nodes as level 3 nodes if:
                  1) we are not in edit mode and
                  2) the node doesn't have any children -->
                <ng-container *ngTemplateOutlet="editMode && !isLoading || (subNode.Children && subNode.Children.length > 0) ? hasChildrenTmpl : noChildrenTmpl ; context { $implicit: subNode }">
                </ng-container>

            </li>
        </ul>

        <!-- Add level 2 node button -->
        <div *ngIf="editMode && !isLoading" class="row-fluid container-level-2">
            <div>
                <button mat-button
                        [routerLink]="['',{ outlets: { modal: ['find-information','add'] } }]"
                        [queryParams]="{ parentId: node.Id, Order: getOrder(node)}"
                        class="mat-flat-button mat-accent">
                    <i class="fa fa-plus mr-1 "></i><span i18n="@@find-information-node-add-heading">Add heading</span>
                </button>
            </div>
        </div>
    </div>

    <!-- Add top level button-->
    <div *ngIf="editMode && !isLoading" class="menu-item col-xs-12 col-sm-6 col-xl-4 container-level-1 ignore-elements">
        <hr />
        <div class="card h-50 add-section border border-dark-color border-dashed mat-accent">
            <div class="align-self-center flex-grow-1 d-flex align-items-center">
                <button [routerLink]="['',{ outlets: { modal: ['find-information','add'] } }]"
                        [queryParams]="{ parentId: '', Order: getOrder()}"
                        class="add-btn mat-button mat-accent">
                    <i class="ms-Icon ms-Icon--Add display-4 d-block"
                       aria-hidden="true"></i>
                    <span i18n="@@find-information-node-add-section"> Add section</span>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- TEMPLATE  used for level 2 nodes -->
<ng-template #hasChildrenTmpl #level2 let-subNode>
    <div class="container-level-2">

        <a *ngIf="!editMode" class="node-style-level-2 link-text-color font-weight-bold"
         [ngClass]="!subNode.Url || subNode.Url === '' ? 'text-decoration-none' : ''" [attr.href]="subNode.Url && subNode.Url !== '' ? subNode.Url : null">{{subNode.Title}}</a>
        <i *ngIf="editMode" class="ms-Icon ms-Icon--GripperDotsVertical drag-handle pl-1 pr-1 " aria-hidden="true"></i>
        <a *ngIf="editMode" class="node-style-level-2 link-text-color font-weight-bold clickable"
           [routerLink]="['',{ outlets: { modal: ['find-information','edit',subNode.Id] } }]">
            {{subNode.Title}}
            <i *ngIf="!isLoading && subNode.ChannelTermNavigationNodes && subNode.ChannelTermNavigationNodes.length > 0"
               [ngClass]="{'fa-tag': subNode.ChannelTermNavigationNodes.length === 1, 'fa-tags': subNode.ChannelTermNavigationNodes.length > 1}"
               class="fa ml-2"></i>
        </a>
        <br>
        <ng-container *ngIf="editMode && !isLoading && languageFilteringEnabled && subNode.LanguageTermNavigationNodes && subNode.LanguageTermNavigationNodes.length > 0">
          <i class="fa fa-flag-o ml-2 mr-2"></i>
          <span class="text-muted"> {{getNodeLanguages(subNode.LanguageTermNavigationNodes)}} </span>
        </ng-container>

        <!-- level 3 nodes -->
        <!-- sortable in edit mode-->
        <ul *ngIf="subNode.Children" [sortablejs]="editMode ? subNode.Children : []" [sortablejsOptions]="editMode ? options : {disabled:true}">
            <li *ngFor="let grandChild of subNode.Children">
                <ng-container *ngTemplateOutlet="noChildrenTmpl ; context { $implicit: grandChild }"></ng-container>
            </li>
        </ul>

        <!-- Add level 3 node button -->
        <span *ngIf="editMode && !isLoading"
              [routerLink]="['',{ outlets: { modal: ['find-information','add'] } }]"
              [queryParams]="{ parentId: subNode.Id, Order: getOrder(subNode)}" class="clickable">
            <button mat-button class="mat-accent mat-icon-button smaller-icon-button">
                <i class="fa fa-plus ml-3 pl-2 pr-2 mt-2 mr-1"></i><span i18n="@@find-information-node-new-link">New link</span>
            </button>
        </span>
    </div>
</ng-template>

<!-- TEMPLATE  used for level 3 nodes and also level 2 nodes WITHOUT children -->
<ng-template #noChildrenTmpl #level3 let-subNode>
    <a *ngIf="!editMode" class="node-style-level-3 link-text-color"
     [ngClass]="!subNode.Url || subNode.Url === '' ? 'text-decoration-none' : ''" [attr.href]="subNode.Url && subNode.Url !== '' ? subNode.Url : null">{{subNode.Title}}</a>
    <i *ngIf="editMode" class="ms-Icon ms-Icon--GripperDotsVertical drag-handle ml-3 pl-1 pr-1 " aria-hidden="true"></i>
    <a *ngIf="editMode" class="node-style-level-3 link-text-color clickable"
       [routerLink]="['',{ outlets: { modal: ['find-information','edit',subNode.Id] } }]">
        {{subNode.Title}}
        <i *ngIf="!isLoading && subNode.ChannelTermNavigationNodes && subNode.ChannelTermNavigationNodes.length > 0"
           [ngClass]="{'fa-tag': subNode.ChannelTermNavigationNodes.length === 1, 'fa-tags': subNode.ChannelTermNavigationNodes.length > 1}"
           class="fa ml-2"></i>
    </a>
    <br>
    <ng-container *ngIf="editMode && !isLoading && languageFilteringEnabled && subNode.LanguageTermNavigationNodes && subNode.LanguageTermNavigationNodes.length > 0">
      <i class="fa fa-flag-o ml-4 mr-2"></i>
      <span class="text-muted"> {{getNodeLanguages(subNode.LanguageTermNavigationNodes)}} </span>
    </ng-container>
</ng-template>

<!-- TEMPLATE  loading -->
<ng-template #loading>
    <div>
        <app-widget-placeholder></app-widget-placeholder>
    </div>
</ng-template>
